import { tv } from 'tailwind-variants'

export const headerNavVariants = tv({
  slots: {
    container: 'w-full fixed z-[700]'
  }
})
